import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

import { PublicOnboardingService } from "../../../services/api/public-onboarding.service";
import { ConsumerActions } from "../../actions/consumer.actions";
import { FailState } from "../../models/fail-state";

@Injectable()
export class ConsumerOnboardingEffects {
	activate = createEffect(() =>
		this.actions.pipe(
			ofType(ConsumerActions.account.create),
			switchMap((action) =>
				this.publicOnboardingService.createNewConsumer(action).pipe(
					map(() => ConsumerActions.account.createSuccess()),
					catchError((error) =>
						of(ConsumerActions.account.createFail(new FailState(error)))
					)
				)
			)
		)
	);

	constructor(
		private actions: Actions,
		private publicOnboardingService: PublicOnboardingService
	) {}
}
